import { useContractInfo } from '@/hooks/useContractInfo'
import { TrendingUp, Users, Clock, Shield } from 'lucide-react'
import { Card } from './ui/Card'

export const ContractStats = () => {
  const { data: contractInfo, isLoading } = useContractInfo()

  if (isLoading || !contractInfo) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {[...Array(4)].map((_, i) => (
          <Card key={i} className="animate-pulse">
            <div className="h-20 bg-slate-700 rounded"></div>
          </Card>
        ))}
      </div>
    )
  }

  const stats = [
    {
      icon: TrendingUp,
      label: 'Current Price',
      value: `${contractInfo.currentPriceFormatted} ETH/BNB`,
      color: 'text-green-400',
      bgColor: 'bg-green-500/10',
    },
    {
      icon: Users,
      label: 'Minted',
      value: `${contractInfo.totalMinted.toString()} / ${contractInfo.maxSupply.toString()}`,
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10',
    },
    {
      icon: Clock,
      label: 'Status',
      value: contractInfo.whitelistActive ? 'Whitelist' : 'Public',
      color: contractInfo.whitelistActive ? 'text-yellow-400' : 'text-purple-400',
      bgColor: contractInfo.whitelistActive ? 'bg-yellow-500/10' : 'bg-purple-500/10',
    },
    {
      icon: Shield,
      label: 'Refund',
      value: '7 Days / 90%',
      color: 'text-pink-400',
      bgColor: 'bg-pink-500/10',
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat, index) => {
        const Icon = stat.icon
        return (
          <Card key={index} className="hover:scale-105 transition-transform">
            <div className="flex items-center gap-4">
              <div className={`w-12 h-12 rounded-lg ${stat.bgColor} flex items-center justify-center`}>
                <Icon className={`w-6 h-6 ${stat.color}`} />
              </div>
              <div>
                <p className="text-sm text-slate-400">{stat.label}</p>
                <p className={`text-lg font-bold ${stat.color}`}>{stat.value}</p>
              </div>
            </div>
          </Card>
        )
      })}

      {/* Progress Bar */}
      <Card className="col-span-1 md:col-span-2 lg:col-span-4">
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-sm text-slate-400">Mint Progress</span>
            <span className="text-sm font-medium text-white">
              {contractInfo.progress.toFixed(1)}%
            </span>
          </div>
          <div className="w-full h-3 bg-slate-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-500"
              style={{ width: `${contractInfo.progress}%` }}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
